// src/pages/StyleWiseBacklog.jsx



import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";



import { Button, Card, DatePicker, Input, InputNumber, Select, Space, Table, Tabs, Typography, message, Modal } from "antd";



import { FileTextOutlined, ReloadOutlined, SaveOutlined, HistoryOutlined, SearchOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";



import dayjs from "dayjs";



import { BASE_URL } from "../services/BaseUrl";



import "../css/sm-art-common.css";



const { Title, Text } = Typography;



const EDIT_FIELDS = ["backlog_with_pm", "backlog_without_pm", "backlog_late_material", "remarks"];



const fmt = (v) => (v === null || v === undefined || v === "" ? "—" : String(v));



const quantity = (v) => (v == null || v === "" ? "—" : Number(v).toLocaleString("en-IN"));



const whole = (v) => v !== null && v !== undefined && v !== "" && Number.isInteger(Number(v));



const textSearch = (value) => String(value ?? "").toLowerCase();



function getField(obj, keys) {



  for (const item of [obj?.data, obj?.user, obj]) {



    if (!item || typeof item !== "object") continue;



    for (const key of keys) {



      if (item[key] !== null && item[key] !== undefined && String(item[key]).trim()) return String(item[key]).trim();



    }



  }



  return "";



}



function getStoredField(keys) {



  if (typeof window === "undefined") return "";



  for (const key of ["userData", "userdata", "user"]) {



    try {



      const found = getField(JSON.parse(localStorage.getItem(key) || "null"), keys);



      if (found) return found;



    } catch (_) { /* invalid stored JSON */ }



  }



  for (const key of keys) {



    const found = localStorage.getItem(key);



    if (found) return found;



  }



  return "";



}



function getUrl(unit, action, params = {}) {



  if (!/^\d+$/.test(String(unit || ""))) throw new Error("Select a valid unit code.");



  const url = new URL(`/index.php/backlog/${unit}/${action}`, BASE_URL.BASE);



  Object.entries(params).forEach(([name, value]) => {



    if (value !== undefined && value !== null && value !== "") url.searchParams.set(name, String(value));



  });



  return url.toString();



}



async function getJSON(url, options) {



  const response = await fetch(url, options);



  const json = await response.json().catch(() => null);



  if (!response.ok || !json || json.status !== true) {



    const error = new Error(json?.message || `Request failed (${response.status})`);



    error.details = json?.data;



    throw error;



  }



  return json;



}



const normalizeRow = (row) => ({ ...row, _key: row.style_key, _errors: [] });



const normalizeEdit = (field, value) => field === "remarks" ? String(value ?? "") : (value == null || value === "" ? null : Number(value));



const changedFields = (original, current) => EDIT_FIELDS.some((field) => normalizeEdit(field, original?.[field]) !== normalizeEdit(field, current?.[field]));



export default function StyleWiseBacklog({ userdata }) {



  const department = getField(userdata, ["dept_ids", "dept", "dept_id", "department_id"]) || getStoredField(["dept_ids", "dept", "dept_id"]);



  const isAdmin = String(department).split(/[,\s]+/).includes("43");



  const authenticatedUnit = getField(userdata, ["unit_code"]) || getStoredField(["unit_code"]);



  const userId = getField(userdata, ["su_id", "user_id", "id"]) || getStoredField(["su_id", "user_id", "id"]);



  const [selectedAdminUnit, setSelectedAdminUnit] = useState(undefined);



  const [unitOptions, setUnitOptions] = useState([]);



  const [unitsLoading, setUnitsLoading] = useState(false);



  const [unitsError, setUnitsError] = useState("");



  const unit = isAdmin ? selectedAdminUnit : authenticatedUnit;



  const [date, setDate] = useState(() => dayjs().format("YYYY-MM-DD"));



  const [search, setSearch] = useState("");



  const [rowFilter, setRowFilter] = useState("all");



  const [tab, setTab] = useState("report");



  const [report, setReport] = useState(null);



  const [rows, setRows] = useState([]);



  const [log, setLog] = useState(null);



  const [styleKeyFilter, setStyleKeyFilter] = useState(undefined);



  const [loading, setLoading] = useState(false);



  const [loadingLog, setLoadingLog] = useState(false);



  const [saving, setSaving] = useState(false);



  const [error, setError] = useState("");



  const [logError, setLogError] = useState("");



  const [notice, setNotice] = useState("");



  const [originalRows, setOriginalRows] = useState([]);



  const [page, setPage] = useState(1);



  const [logPage, setLogPage] = useState(1);



  const reportRequest = useRef(0);



  const logRequest = useRef(0);
  const historyRequest = useRef(0);
  const [historyActionKeys, setHistoryActionKeys] = useState(new Set());
  const [historyReady, setHistoryReady] = useState(false);



  const changedRows = useMemo(() => {



    const original = new Map(originalRows.map((row) => [row.style_key, row]));



    return rows.filter((row) => changedFields(original.get(row.style_key), row));



  }, [rows, originalRows]);



  const dirty = changedRows.length > 0;



  const loadReport = useCallback(async (fresh = false) => {



    const id = ++reportRequest.current;



    setError(""); setLoading(true);



    // Keep the existing report and edits on network failures.



    if (!unit) {



      setReport(null); setRows([]); setOriginalRows([]);



      setLoading(false);



      if (!isAdmin) setError("Unit code is unavailable in the logged-in user details.");



      return;



    }



    try {



      const json = await getJSON(getUrl(unit, "style_report", { date, ...(fresh ? { refresh: 1 } : {}) }));



      if (id !== reportRequest.current) return;



      setReport(json.data);



      const freshRows = Array.isArray(json.data?.rows) ? json.data.rows.map(normalizeRow) : [];



      setRows(freshRows);



      setOriginalRows(freshRows.map((row) => ({ ...row })));



      setNotice("");



      setPage(1);



    } catch (err) { if (id === reportRequest.current) setError(err.message); message.error(err.message); }



    finally { if (id === reportRequest.current) setLoading(false); }



  }, [unit, date, isAdmin]);



  const loadLog = useCallback(async () => {



    const id = ++logRequest.current;



    setLogError(""); setLoadingLog(true);



    if (!unit) { setLoadingLog(false); return; }



    try {



      const json = await getJSON(getUrl(unit, "backlog_split_log", { date, ...(styleKeyFilter ? { style_key: styleKeyFilter } : {}) }));



      if (id === logRequest.current) { setLog(json.data); setLogPage(1); }



    } catch (err) { if (id === logRequest.current) setLogError(err.message); message.error(err.message); }



    finally { if (id === logRequest.current) setLoadingLog(false); }



  }, [unit, date, styleKeyFilter]);



  // Total Finishing backlog cell colors use insert/update history, independently of the
  // Change Log tab's optional style filter and unsaved form changes.
  const loadReportHistory = useCallback(async () => {
    const requestId = ++historyRequest.current;
    setHistoryReady(false);
    setHistoryActionKeys(new Set());
    if (!unit) return;
    try {
      const result = await getJSON(getUrl(unit, "backlog_split_log", { date }));
      if (requestId !== historyRequest.current) return;
      const entries = Array.isArray(result.data?.log) ? result.data.log : [];
      setHistoryActionKeys(new Set(
        entries
          .filter((entry) => ["insert", "update"].includes(String(entry.action || "").trim().toLowerCase()))
          .map((entry) => String(entry.style_key || ""))
          .filter(Boolean)
      ));
      setHistoryReady(true);
    } catch (err) {
      // A failed history request must never be presented as confirmed no history (green).
      if (requestId === historyRequest.current) {
        setHistoryReady(false);
        message.warning(`Could not load backlog history for row colors: ${err.message}`);
      }
    }
  }, [unit, date]);

  useEffect(() => {
    loadReportHistory();
    return () => { historyRequest.current += 1; };
  }, [loadReportHistory]);

  // Admin units come from the central all-unit API, not a frontend list.



  // Fetch without refresh=1 to use the backend cache.



  useEffect(() => {



    if (!isAdmin) return undefined;



    let cancelled = false;



    const loadUnits = async () => {



      setUnitsLoading(true);



      setUnitsError("");



      try {



        const url = new URL("/index.php/backlog/unit_summary", BASE_URL.BASE);



        url.searchParams.set("date", date);



        const result = await getJSON(url.toString());



        if (cancelled) return;



        const items = result?.data?.units;



        if (!Array.isArray(items)) throw new Error("Unit list is missing from the all-unit backlog response.");



        const seen = new Set();



        const options = items.reduce((list, item) => {



          const code = String(item?.unit_code ?? "").trim();



          if (!/^\d+$/.test(code) || seen.has(code)) return list;



          seen.add(code);



          const name = String(item?.unit_name || `Unit ${code}`).trim();



          list.push({ value: code, label: `${name} (${code})` });



          return list;



        }, []).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));



        setUnitOptions(options);



        // Keep current selection when valid; otherwise ask admin to choose.



        setSelectedAdminUnit((current) => options.some((opt) => opt.value === current) ? current : undefined);



      } catch (err) {



        if (!cancelled) {



          setUnitsError(err.message || "Unable to load units.");



          message.error(err.message || "Unable to load units.");



        }



      } finally {



        if (!cancelled) setUnitsLoading(false);



      }



    };



    loadUnits();



    return () => { cancelled = true; };



  }, [isAdmin, date]);



  useEffect(() => { loadReport(); }, [loadReport]);



  useEffect(() => { if (tab === "log") loadLog(); }, [tab, loadLog]);



  const onChangeDate = (value) => {



    if (!value) return;



    const next = value.format("YYYY-MM-DD");



    if (saving || loading) return;



    if (dirty) Modal.confirm({ title: "Discard unsaved changes?", onOk: () => { setStyleKeyFilter(undefined); setDate(next); } });



    else { setStyleKeyFilter(undefined); setDate(next); }



  };



  const changeUnit = (next) => {



    if (saving || loading) return;



    if (dirty) Modal.confirm({ title: "Discard unsaved changes?", onOk: () => { setStyleKeyFilter(undefined); setSelectedAdminUnit(next); } });



    else { setStyleKeyFilter(undefined); setSelectedAdminUnit(next); }



  };



  const updateRow = (key, field, value) => {



    setRows((prev) => prev.map((row) => row._key === key ? { ...row, [field]: value, _errors: [] } : row));



    setNotice("");



  };



  const rowProblems = (row) => {



    const errors = [];



    const three = EDIT_FIELDS.slice(0, 3);



    if (three.some((field) => !whole(row[field]))) errors.push("All three backlog values must be whole numbers.");



    else if (Number(row.backlog_without_pm) < 0 || Number(row.backlog_late_material) < 0) errors.push("Without PM and Late Material cannot be negative.");



    if (String(row.remarks || "").length > 500) errors.push("Remarks cannot exceed 500 characters.");



    return errors;



  };



  const save = async () => {
    if (isAdmin) return; // admin is view-only



    if (!report?.editable) return message.warning("API marked this date as not editable.");



    if (!userId) return message.error("Logged-in user ID is unavailable.");



    if (!changedRows.length) return message.info("No changes to save.");



    const changedKeys = new Set(changedRows.map((row) => row.style_key));



    const checked = rows.map((row) => ({ ...row, _errors: changedKeys.has(row.style_key) ? rowProblems(row) : [] }));



    setRows(checked);



    const firstLocalError = checked.find((row) => row._errors.length);

    if (firstLocalError) {

      message.error({ content: `${firstLocalError.style_no || firstLocalError.item_no || "Style"}: ${firstLocalError._errors[0]}`, duration: 6 });

      return;

    }



    setSaving(true); setError(""); setNotice("");



    const submitted = changedRows.map((row) => ({ ...row }));



    try {



      const json = await getJSON(getUrl(unit, "save_backlog_split"), {



        method: "POST", headers: { "Content-Type": "application/json" },



        body: JSON.stringify({ user_id: userId, date, rows: submitted.map((row) => ({



          style_key: row.style_key,



          backlog_with_pm: Number(row.backlog_with_pm),



          backlog_without_pm: Number(row.backlog_without_pm),



          backlog_late_material: Number(row.backlog_late_material),



          remarks: row.remarks ?? "",



        })) }),



      });



      const d = json.data || {};



      setNotice(`${json.message || "Saved"} — ${fmt(d.inserted)} new, ${fmt(d.updated)} updated, ${fmt(d.unchanged)} unchanged.`);



      message.success(json.message || "Backlog saved.");



      // Save succeeded. A refresh failure must not report a failed save.



      const settledRows = rows.map((row) => ({ ...row, _errors: [] }));



      setRows(settledRows);



      setOriginalRows(settledRows.map((row) => ({ ...row })));



      try {



        const refreshed = await getJSON(getUrl(unit, "style_report", { date, refresh: 1 }));



        if (refreshed.data) {



          const freshRows = Array.isArray(refreshed.data.rows) ? refreshed.data.rows.map(normalizeRow) : [];



          setReport(refreshed.data);



          setRows(freshRows);



          setOriginalRows(freshRows.map((row) => ({ ...row })));



        }



      } catch {



        message.warning("Saved successfully, but the updated report could not be reloaded.");



      }



      await loadReportHistory();
      if (tab === "log") loadLog();



    } catch (err) {



      setError(err.message);

      const issues = err.details?.errors;

      const firstIssue = Array.isArray(issues) ? issues.find((issue) => issue?.message) : null;

      message.error({

        content: firstIssue?.message || err.message || "Unable to save backlog.",

        duration: 7,

      });



      if (Array.isArray(issues)) setRows((prev) => {



        const indexByKey = new Map(submitted.map((row, i) => [row.style_key, i]));



        return prev.map((row) => ({ ...row, _errors: issues.filter((issue) => issue.style_key === row.style_key || (issue.style_key == null && issue.row === indexByKey.get(row.style_key))).map((issue) => issue.message) }));



      });



    } finally { setSaving(false); }



  };



  // Admin (department 43) can only view. Only unit logins can edit and save.
  const editingAllowed = !isAdmin && report?.editable === true && !saving && !loading;



  const inputColumn = (field, label, width) => ({



    title: label, dataIndex: field, key: field, width, align: "right", className: "swb-green-head",



    render: (value, record) => isAdmin ? <span className="swb-view-value">{quantity(value)}</span> : <InputNumber className="swb-qty-input swb-editable-control" precision={0} controls={false}



      value={value === null || value === undefined ? null : Number(value)}



      min={field === "backlog_with_pm" ? undefined : 0}



      disabled={!editingAllowed} onChange={(next) => updateRow(record._key, field, next)} />,



  });



  const columns = [



    { title: "Sl.No.", dataIndex: "sl_no", width: 62, align: "center" },



    { title: "Buyer", dataIndex: "buyer", width: 190, ellipsis: { showTitle: false }, render: (value) => <span className="swb-buyer-text" title={value}>{value}</span> },



    { title: "Style No.", dataIndex: "style_no", width: 148, render: (value) => <span className="swb-style-text">{value}</span> },



    { title: "Item", dataIndex: "item_no", width: 88,  },



    ...[



      ["order_qty", "Order Qty"], ["today_sew_qty", "Today Kanban Audited"],



      ["total_sew_qty", "Total Kanban Audited"], ["today_pack_qty", "Today Carton Audited"], ["total_packed", "Total Carton Audited"],



    ].map(([dataIndex, title]) => ({ title, dataIndex, width: 104, align: "right", render: quantity })),



    inputColumn("backlog_with_pm", "Finishing backlog with Trims", 175),



    inputColumn("backlog_without_pm", "Finishing backlog without Trims", 175),



    inputColumn("backlog_late_material", "Finishing backlog with Late Receipt of Trims", 190),



    {
      title: "Total Finishing backlog", dataIndex: "total_backlog", width: 145, align: "right",
      onCell: (record) => ({
        className: !historyReady
          ? "swb-total-history-pending"
          : historyActionKeys.has(String(record.style_key))
            ? "swb-total-history-updated"
            : "swb-total-history-unchanged",
      }),
      render: (v) => <strong>{quantity(v)}</strong>,
    },



    { title: "Remarks", dataIndex: "remarks", width: 230, className: "swb-green-head",



      render: (v, r) => isAdmin ? <span className="swb-view-value">{v || "—"}</span> : <Input className="swb-editable-control swb-remarks-input" value={v ?? ""} maxLength={500} disabled={!editingAllowed} onChange={(e) => updateRow(r._key, "remarks", e.target.value)} /> },



  ];



  const changedKeysForFilter = useMemo(() => new Set(changedRows.map((r) => r.style_key)), [changedRows]);



  const displayedRows = useMemo(() => {



    const terms = search.trim().toLowerCase().split(/\s+/).filter(Boolean);



    return rows.filter((row) => {



      if (rowFilter === "edited" && !changedKeysForFilter.has(row.style_key)) return false;



      if (rowFilter === "saved" && !row.entered) return false;



      if (rowFilter === "pending" && row.entered) return false;



      if (rowFilter === "errors" && !row._errors?.length) return false;



      const content = [row.buyer, row.style_no, row.item_no, row.remarks, row.sl_no].map(textSearch).join(" ");



      return terms.every((term) => content.includes(term));



    });



  }, [rows, search, rowFilter, changedKeysForFilter]);



  const sumFields = ["order_qty", "today_sew_qty", "total_sew_qty", "today_pack_qty", "total_packed", "backlog_with_pm", "backlog_without_pm", "backlog_late_material", "total_backlog"];



  // The summary follows the visible search result, not the unfiltered API total.



  const totals = Object.fromEntries(sumFields.map((key) => [key, displayedRows.reduce((sum, row) => sum + Number(row[key] || 0), 0)]));



  const logRows = Array.isArray(log?.log) ? log.log : [];

  const logStyleMap = new Map(rows.map((row) => [row.style_key, row]));
  const logNumber = (value) => value === null || value === undefined || value === ""
    ? "—" : Number(value).toLocaleString("en-IN");
  const logFieldValue = (value, key) => {
    if (!value || !Object.prototype.hasOwnProperty.call(value, key)) return "—";
    if (key === "remarks") return value[key] == null || value[key] === "" ? "Empty" : String(value[key]);
    return logNumber(value[key]);
  };
  const logDifference = (entry, key) => {
    const oldValue = logFieldValue(entry.old_values, key);
    const newValue = logFieldValue(entry.new_values, key);
    if (entry.action === "insert" || oldValue === "—") return <span className="swb-log-value">{newValue}</span>;
    if (oldValue === newValue) return <span className="swb-log-value">{newValue}</span>;
    return (
      <span className="swb-log-diff">
        <span className="swb-log-old">{oldValue}</span>
        <span className="swb-log-arrow">→</span>
        <span className="swb-log-new">{newValue}</span>
      </span>
    );
  };
  const showLogDetails = (entry) => {
    const selectedStyle = logStyleMap.get(entry.style_key);
    Modal.info({
      title: "Backlog Change Details",
      width: 540,
      okText: "Close",
      content: (
        <div className="swb-log-detail">
          <div><span>Style</span><strong>{selectedStyle ? `${selectedStyle.style_no} / ${selectedStyle.item_no}` : "—"}</strong></div>
          <div><span>Style Key</span><code>{entry.style_key}</code></div>
          <div><span>Action</span><strong>{entry.action === "insert" ? "Inserted" : entry.action === "update" ? "Updated" : fmt(entry.action)}</strong></div>
          <div><span>Changed By</span><strong>{fmt(entry.changed_by)}</strong></div>
          <div><span>Changed On</span><strong>{fmt(entry.changed_on)}</strong></div>
          <div><span>IP Address</span><strong>{fmt(entry.ip_address)}</strong></div>
          <div className="swb-log-detail-subtitle">Previous and new values</div>
          {[
            ["With PM", "backlog_with_pm"],
            ["Without PM", "backlog_without_pm"],
            ["Late Material", "backlog_late_material"],
            ["Remarks", "remarks"],
            ["Total Backlog", "total_backlog"],
          ].map(([label, key]) => (
            <div key={key}><span>{label}</span><strong>{logFieldValue(entry.old_values, key)} → {logFieldValue(entry.new_values, key)}</strong></div>
          ))}
        </div>
      ),
    });
  };
  const logColumns = [
    {
      title: "Style / Item", dataIndex: "style_key", key: "style_key", width: 182,
      render: (key) => {
        const item = logStyleMap.get(key);
        return <div className="swb-log-style"><strong>{item?.style_no || `${String(key || "").slice(0, 12)}…`}</strong>
          <span>{item ? `${item.item_no || "—"} · ${item.buyer || "—"}` : "Style key"}</span></div>;
      },
    },
    {
      title: "Action", dataIndex: "action", key: "action", width: 92,
      render: (action) => <span className={`swb-log-action swb-log-action-${action === "insert" ? "insert" : "update"}`}>
        {action === "insert" ? "Inserted" : action === "update" ? "Updated" : fmt(action)}
      </span>,
    },
    { title: "With PM", key: "backlog_with_pm", width: 128, render: (_, record) => logDifference(record, "backlog_with_pm") },
    { title: "Without PM", key: "backlog_without_pm", width: 133, render: (_, record) => logDifference(record, "backlog_without_pm") },
    { title: "Late Material", key: "backlog_late_material", width: 133, render: (_, record) => logDifference(record, "backlog_late_material") },
    { title: "Remarks", key: "remarks", width: 154, render: (_, record) => logDifference(record, "remarks") },
    { title: "Total Backlog", key: "total_backlog", width: 115, render: (_, record) => logDifference(record, "total_backlog") },
    {
      title: "Changed On", dataIndex: "changed_on", key: "changed_on", width: 155,
      render: (value) => value && dayjs(value).isValid() ? dayjs(value).format("DD-MM-YYYY HH:mm:ss") : fmt(value),
    },
    { title: "Changed By", dataIndex: "changed_by", key: "changed_by", width: 100, render: fmt },
    {
      title: "Details", key: "details", width: 85, align: "center",
      render: (_, entry) => <Button size="small" className="swb-log-details-btn" onClick={() => showLogDetails(entry)}>View</Button>,
    },
  ];


  // ===== Excel / PDF download (uses the same headings as the table) =====
  const exportColumns = columns.filter((col) => typeof col.title === "string" && col.dataIndex);
  const exportFileName = `Style_Wise_Backlog_${report?.unit_name || "Unit"}_${date}`.replace(/[^\w.-]+/g, "_");
  const exportRows = () => {
    const header = exportColumns.map((col) => col.title);
    const body = displayedRows.map((row) => exportColumns.map((col) => {
      const value = row[col.dataIndex];
      if (value === null || value === undefined || value === "") return "";
      return sumFields.includes(col.dataIndex) && Number.isFinite(Number(value)) ? Number(value) : value;
    }));
    const totalRow = exportColumns.map((col, i) => (i === 0 ? "Total" : sumFields.includes(col.dataIndex) ? totals[col.dataIndex] : ""));
    return { header, body, totalRow };
  };
  const onDownloadExcel = async () => {
    if (!displayedRows.length) return message.warning("No data to export");
    try {
      const XLSX = await import("xlsx");
      const { header, body, totalRow } = exportRows();
      const sheet = XLSX.utils.aoa_to_sheet([
        ["Finishing Backlog – Style wise"],
        [`${report?.unit_name || ""}   Date: ${dayjs(date).format("DD/MM/YYYY")}`],
        [],
        header,
        ...body,
        totalRow,
      ]);
      sheet["!cols"] = header.map((label) => ({ wch: Math.max(12, Math.min(40, String(label).length + 2)) }));
      const book = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(book, sheet, "Style wise");
      XLSX.writeFile(book, `${exportFileName}.xlsx`);
    } catch {
      message.error("Excel download failed");
    }
  };
  const onDownloadPDF = async () => {
    if (!displayedRows.length) return message.warning("No data to export");
    try {
      const { jsPDF } = await import("jspdf");
      const autoTableModule = await import("jspdf-autotable");
      const autoTable = autoTableModule.default || autoTableModule.autoTable;
      const { header, body, totalRow } = exportRows();
      const pdf = new jsPDF({ orientation: "landscape", format: "a4" });
      pdf.setFontSize(14);
      pdf.text("Finishing Backlog – Style wise", 10, 14);
      pdf.setFontSize(9);
      pdf.text(`${report?.unit_name || ""}   Date: ${dayjs(date).format("DD/MM/YYYY")}`, 10, 20);
      const show = (v) => (typeof v === "number" ? v.toLocaleString("en-IN") : String(v ?? ""));
      autoTable(pdf, {
        startY: 24,
        head: [header],
        body: body.map((r) => r.map(show)),
        foot: [totalRow.map(show)],
        theme: "grid",
        styles: { fontSize: 6.5, cellPadding: 1.5, overflow: "linebreak" },
        headStyles: { fillColor: [33, 100, 60], textColor: 255, fontStyle: "bold" },
        footStyles: { fillColor: [235, 240, 245], textColor: 20, fontStyle: "bold" },
        margin: { left: 6, right: 6 },
      });
      pdf.save(`${exportFileName}.pdf`);
    } catch {
      message.error("PDF download failed");
    }
  };

  return <div className="sm-page style-wise-backlog-page unified-report-page"><div className="sm-page-inner"><section className="unified-panel">



    <div className="swb-page-heading">

      <Title level={3} className="sm-page-title"><FileTextOutlined /> Finishing Backlog – Style wise</Title>

      <Text type="secondary">{report?.unit_name || log?.unit_name || "Style-wise finishing backlog"}{report ? ` · ${fmt(report.style_count)} styles · ${fmt(report.entered_count)} saved` : ""}</Text>

    </div>



    <Tabs activeKey="report" onChange={setTab} className="swb-tabs" items={[



      { key: "report", label: <span><FileTextOutlined /> Style-wise Report</span> },







    ]} />



    {tab === "report" ? <>



      <div className="swb-table-filters swb-unified-filters">

        {isAdmin && <Select placeholder="Select Unit" showSearch optionFilterProp="label" className="swb-unit-select" options={unitOptions} loading={unitsLoading} disabled={unitsLoading || saving} notFoundContent={unitsError || "No units available"} value={selectedAdminUnit} onChange={changeUnit} />}

        <Input className="swb-table-search" prefix={<SearchOutlined />} placeholder="Search buyer, style, item or remarks" value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} allowClear />

        <Select className="swb-row-filter" value={rowFilter} onChange={(value) => { setRowFilter(value); setPage(1); }} options={[{value:"all",label:"All styles"},{value:"edited",label:"Edited only"},{value:"saved",label:"Saved styles"},{value:"pending",label:"Not saved"},{value:"errors",label:"With errors"}]} />

        <DatePicker value={dayjs(date)} onChange={onChangeDate} allowClear={false} format="DD/MM/YYYY" className="swb-date" disabled={saving || loading} />

        <Button icon={<ReloadOutlined />} loading={loading} onClick={() => dirty ? Modal.confirm({ title: "Discard unsaved changes?", onOk: () => loadReport(true) }) : loadReport(true)}>Refresh</Button>

        {!isAdmin && dirty && <Button disabled={saving || loading} onClick={() => { setRows(originalRows.map((row) => ({ ...row, _errors: [] }))); setError(""); setNotice(""); }}>Undo</Button>}

        {!isAdmin && <Button className="swb-save-btn" type="primary" icon={<SaveOutlined />} loading={saving} disabled={!editingAllowed || !dirty} onClick={save}>Save{dirty ? ` (${changedRows.length})` : ""}</Button>}

        <Button icon={<FileExcelOutlined />} disabled={!displayedRows.length} onClick={onDownloadExcel}>Excel</Button>

        <Button icon={<FilePdfOutlined />} disabled={!displayedRows.length} onClick={onDownloadPDF}>PDF</Button>

        <span className="swb-record-count">{displayedRows.length} / {rows.length} styles{report && Number(report.mismatch_count) > 0 ? ` · ${report.mismatch_count} mismatches` : ""}</span>

        {(search || rowFilter !== "all") && <Button size="small" type="link" onClick={() => { setSearch(""); setRowFilter("all"); setPage(1); }}>Clear</Button>}

      </div>



      <div className="unified-table-wrap swb-table-card">



        <Table className="swb-table unified-table" rowKey="_key" dataSource={displayedRows}



          columns={columns} scroll={{ x: "max-content" }} size="small"



          pagination={{ current: page, onChange: setPage, pageSize: 10, showSizeChanger: false, className: "swb-pagination", showTotal: (total, range) => `${range[0]}–${range[1]} of ${total}` }}







          summary={() => displayedRows.length ? <Table.Summary><Table.Summary.Row>



            <Table.Summary.Cell index={0} colSpan={4}><strong>Total</strong></Table.Summary.Cell>



            {sumFields.map((key, i) => <Table.Summary.Cell key={key} index={i + 4} align="right"><strong>{quantity(totals[key])}</strong></Table.Summary.Cell>)}



            <Table.Summary.Cell index={13} />



          </Table.Summary.Row></Table.Summary> : null}



        />



      </div>



    </> : <>



      <div className="swb-log-filters swb-unified-filters">

        {isAdmin && <Select placeholder="Select Unit" showSearch optionFilterProp="label" className="swb-unit-select" options={unitOptions} loading={unitsLoading} disabled={unitsLoading || saving} notFoundContent={unitsError || "No units available"} value={selectedAdminUnit} onChange={changeUnit} />}

        <Select allowClear showSearch optionFilterProp="label" placeholder="All styles" className="swb-style-filter" value={styleKeyFilter} onChange={(next) => { setStyleKeyFilter(next); setLogPage(1); }} options={rows.map((row) => ({ value: row.style_key, label: `${row.style_no} / ${row.item_no}` }))} />

        <DatePicker value={dayjs(date)} onChange={onChangeDate} allowClear={false} format="DD/MM/YYYY" className="swb-date" disabled={saving || loadingLog} />

        <Button icon={<ReloadOutlined />} loading={loadingLog} onClick={loadLog}>Refresh</Button>

        {log && <Text type="secondary" className="swb-record-count">{fmt(log.unit_name)} · {fmt(log.date)}</Text>}

      </div>



      <div className="unified-table-wrap swb-table-card">



        <Table rowKey={(r, i) => `${r.style_key}-${r.changed_on}-${i}`} className="swb-table swb-log-table unified-table" size="small" columns={logColumns}



          dataSource={logRows}
          rowClassName={(record) => {
            const action = String(record.action || "").toLowerCase();
            return action === "update" ? "swb-log-updated" : action === "insert" ? "swb-log-inserted" : "";
          }}
          scroll={{ x: "max-content" }} pagination={{ current: logPage, onChange: setLogPage, pageSize: 10, showSizeChanger: false, className: "swb-pagination" }} />



      </div>



    </>}



  </section></div></div>;



}